import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert } from "redux/slices/alertSlice";
import { Modal, Button, ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";

/**
 * 파일명: alert.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 공통 alert, comfirm 컴포넌트
 */
function Alert() {
  //dispatch
  const dispatch = useDispatch();

  const { t } = useTranslation();

  //payload
  const payload = useSelector((state) => state.alert);

  //close
  const closeEventHandler = () => {
    payload.cancelEventHandler();
    dispatch(closeAlert());
  };

  //submit
  const submitEventHandler = () => {
    payload.submitEventHandler();
    closeEventHandler();
  };

  // Modal.config({});
  ConfigProvider.config({});

  return (
    <Modal
      zIndex="1111"
      title={
        <>
          {payload.img !== undefined && payload.img !== "" && payload.img}
          <p>{payload.title}</p>
        </>
      }
      centered
      open={payload.display}
      onOk={() => submitEventHandler()}
      onCancel={() => closeEventHandler()}
      closable={false}
      okText={t("common.button.ok")}
      footer={
        payload.cancleBtn ? (
          <>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    colorPrimaryActive: "#1cb691",
                    colorPrimaryHover: "#1cb691",
                    fontFamily: "Spoqa Han Sans Neo",
                  },
                },
              }}
            >
              <Button onClick={closeEventHandler}>
                {t("common.button.cancel")}
              </Button>
            </ConfigProvider>
            <Button type="primary" onClick={submitEventHandler}>
              {t("common.button.ok")}
            </Button>
          </>
        ) : (
          <Button type="primary" onClick={submitEventHandler}>
            {t("common.button.ok")}
          </Button>
        )
      }
      cancelText={t("common.button.cancel")}
    >
      {payload.content}
    </Modal>
  );
}

export default Alert;
